import { Grid, Hidden, useTheme } from '@material-ui/core'
import React, { useState } from 'react'
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import { withRouter } from "react-router-dom";
import { useAlert } from "react-alert";
import {getUserDeuda} from "../Redux/DeudasClientes.js"
import servicableLogo from '../Assets/images/servicableLogo.png'
import futurityLogo from '../Assets/images/futurityLogo.png'
// import {
//     Link
//   } from "react-router-dom";
const useStylesCustom = makeStyles(theme => ({
    cedula: {
      [theme.breakpoints.up('lg')]: {
        textAlign:'right'
      },
      [theme.breakpoints.down('md')]: {
        textAlign:'center'
      }
    },
    button:{
        [theme.breakpoints.up('md')]: {
            textAlign:'center', 
            marginTop:'15px',
            marginLeft:'43px',
            width:'100%'
          },
          [theme.breakpoints.down('md')]: {
            textAlign:'center', 
            marginTop:'15px',
            width:'98%'
          }
    },
    textFooter:{
        [theme.breakpoints.up('lg')]: {
            fontSize:'18px',
            textAlign:'center',
            marginTop: '1%',
            marginBottom:'14px',
        },
        [theme.breakpoints.down('md')]: {
            fontSize:'18px',
            textAlign:'center',
            marginTop: '1%',
            marginBottom:'14px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize:'14px',
            textAlign:'center',
            marginTop: '1%',
            marginBottom:'14px',
            marginLeft:'15px',
            marginRight:'6px'
        },
        [theme.breakpoints.down('xs')]: {
            fontSize:'14px',
            textAlign:'center',
            marginTop: '1%',
            marginBottom:'14px',
        }
        
    }
  }));
const useStyles = makeStyles({
    root: {
      backgroundColor: '#fafafa',
      marginTop: '1rem',
      marginLeft:'1rem',
      marginRight: '1rem'
    },
    
    media: {
        width:'100%',
        minWidth:"10%",
        paddingTop: '1%',
        paddingBottom: '1%',
        marginLeft:'2%',
      },
    mediaLarge: {
    width:'50%',
    minWidth:"10%",
    paddingTop: '1%',
    paddingBottom: '1%',
    marginLeft:'2%',
    },
    Tipografia:{
        paddingBottom: '4%',
        marginLeft:'2%',
        fontSize: '300%',
        textAlign: 'center',
    }
  });

const ConsultarDeudas =  (props) => {
    const alert = useAlert();
    const classes =  useStyles();
    const classesCustom =  useStylesCustom();
    const [identificacion, setidentificacion] = useState("");
    const consultarcliente = async () =>{
    const clienteApi = await getUserDeuda(identificacion) //0100100296
        const cliente = clienteApi //clientes.find(x => x.cedula === identificacion)
        if (cliente){
            props.history.push('/DeudaCliente', { ...cliente })
        }else{
            alert.error("Cliente no encontrado!");
        }
    }
    return (
        <Card className={classes.root}>
            <Grid container>
                <Hidden xsDown smDown>
                    <Grid item xs={12} lg={12} style={{textAlign: 'center'}} >
                        <img  className={classes.mediaLarge}  src={futurityLogo}   alt="Italian Trulli"/>
                    </Grid>
                </Hidden>
                <Grid item xs={12} lg={12}>
                <Hidden mdUp>
                    <Grid item xs={12} lg={12}  style={{textAlign: 'center'}}>
                        <img className={classes.media} style={{textAlign: 'center'}} src={futurityLogo} alt="Italian Trulli"/>
                    </Grid>
                </Hidden>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} lg={5}>
                    <Typography className={classesCustom.cedula}  style={{ marginTop:'22px', fontSize:'20px'}} variant="body2" color="textSecondary" component="p">
                        CEDULA/RUC: 
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={2}>
                    <TextField 
                                style={{textAlign:'right', marginLeft:'6%',width:'90%'}} 
                                id="input-with-icon-grid" 
                                label="Identificacion" 
                                value={identificacion}
                                onChange={(e) => setidentificacion(e.target.value) }
                                />
                </Grid>
                <Grid item xs={12} lg={4} style={{textAlign:'center'}}>
                        <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.button}
                                startIcon={<SearchIcon />}
                                className={classesCustom.button}
                                onClick={consultarcliente}
                            >
                                Consultar
                        </Button>
                </Grid>
            </Grid>
            <br></br>
            <Grid container>
                <Grid item xs={12} lg={12}>
                    <Typography style={{textAlign:'center', fontSize: '30px', marginTop: '1%'}} variant="body2" color="textSecondary" component="p">
                        CONTACTOS
                    </Typography>
                    <Typography style={{textAlign:'center', fontSize: '165%', marginTop: '1PX', color:'red'}} variant="body2"  component="p">
                        <strong>CALL CENTER:</strong> 07 500 3636
                    </Typography>
                    <Typography className={classesCustom.textFooter}variant="body2" color="textSecondary" component="p">
                                <span style={{display:"inlineBlock",
                                            borderBottom:"1px solid red",
                                            borderWidth:"15",
                                            paddingBottom:"2px"}}>
                                    <strong>Oficina Matriz: </strong>Av. González Suarez s/n y Av. Los Andes
                                </span>
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={12}>
                    <Grid container style={{marginTop: '3%'}}>
                        <Grid item xs={12} xl={4} sm={4} md={4} lg={4}>
                            <Typography className={classesCustom.textFooter}  variant="body2" color="textSecondary" component="p">
                                <strong>Sucursal 1: </strong>Av. Daniel Cañizares y Duitama <br></br> (Las Orquideas)
                            </Typography>
                        </Grid>
                        <Grid item xs={12} xl={4} sm={4} md={4} lg={4}>
                            <Typography className={classesCustom.textFooter}  variant="body2" color="textSecondary" component="p">
                                <strong> Sucursal 2: </strong>Mall del Río
                            </Typography>
                        </Grid>
                        <Grid item  xs={12} xl={4} sm={4} md={4} lg={4}>
                            <Typography className={classesCustom.textFooter}  variant="body2" color="textSecondary" component="p">
                                <strong>Sucursal 3 : </strong>Isla Centro Comercial <br></br> Monay Shopping
                            </Typography>
                        </Grid>
                    </Grid>
                        <div item xs={12} lg={4} sm={4} md={4} xl={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography style={{textAlign:'center', fontSize: '18px', marginTop: '1PX', color:'red',fontWeight:'bold'}}  variant="body2" component="p">
                                <p> SERVICABLE CIA LTDA </p>
                            </Typography>
                        </div>
                    {/* <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent:'center'
                        }}>
                            <PhoneIcon style={{ fontSize: 30, color: '#29b6f6' }} /> 
                            <span>099999999</span>
                            <Typography 
                                style={{textAlign:'center', marginLeft:'2rem'}} 
                                variant="body2" 
                                color="textSecondary" 
                                component="p">
                                <WhatsAppIcon style={{ fontSize: 30, color: green[500]}}  />
                            </Typography>
                    </div>  */}
                </Grid>
                {/* <Grid item xs={12} lg={12} >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent:'center'
                    }}>
                        <HomeIcon style={{ fontSize: 30, color: '#e57373',textAlign:'center' }} /> 
                        <span  style={{ textAlign:'center' }}>Av. Gonzales Suarez y los Andes</span>
                    </div> 
                </Grid> */}
            </Grid>
            <br></br>
        </Card>
        
       
    )
}

export default withRouter(ConsultarDeudas)
